import { useEffect, useState } from 'react';
import { adminWaitlist } from '@/lib/api';
import { formatDateShort } from '@/lib/format';

const AdminWaitlist = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { adminWaitlist().then((d) => setItems(d.items || [])); }, []);
  return (
    <div data-testid="admin-waitlist-page">
      <h1 className="font-display text-4xl">Waitlist</h1>
      <div className="mt-6 border border-pd rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] text-muted-sage uppercase">
              <th className="p-3">Email</th>
              <th className="p-3">Source</th>
              <th className="p-3">Created</th>
            </tr>
          </thead>
          <tbody>
            {items.map((w) => (
              <tr key={w.id} className="border-t border-pd">
                <td className="p-3">{w.email}</td>
                <td className="p-3 font-mono text-xs">{w.source}</td>
                <td className="p-3 text-xs text-muted-sage">{formatDateShort(w.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!items.length && <div className="mt-4 font-mono text-sm text-muted-sage">No waitlist yet.</div>}
    </div>
  );
};
export default AdminWaitlist;
